import React from "react"
import "./ads.css"
import ApiService from "../../../Services/ApiService";
import Modal from "./modal.js";
import queryString from "query-string";

class UploadImage extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            file: '',
            campaign_id: '',
            linkedin_company_id: '',
            imagePreviewURL: '',
            version: props.version,
            fetchedImage: false
        };
    }

    componentDidMount() {
        let params = queryString.parse(window.location.search.substring(1));
        if (params) {
            let campaignId = params.campaign_id;
            let linkedinCompanyId = params.id;
            this.setState({
                    ...this.state,
                    campaign_id: campaignId,
                    linkedin_company_id: linkedinCompanyId
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.state.fetchedImage) {
            return;
        }

        if (this.state.imagePreviewURL === '' && prevProps.imageUrl) {
            this.setState({...this.state, imagePreviewURL: prevProps.imageUrl})
        }
        else if (this.state.imagePreviewURL === '' && prevProps.imageUrl === null) {
               this.getImageFromLocalStorage();
        }

    }

    getImageFromLocalStorage()
    {
        var adNumber = this.state.version === "A" ? 1 : 2;

        let url = "/api/streamCampaignCompanyPhoto?campaign_id=" + this.state.campaign_id
            + "&linkedin_company_id=" + this.state.linkedin_company_id
            + "&ad_number=" + adNumber;

        if (this.state.linkedin_company_id) {
            ApiService.get(url)
                .then(response => {
                    if (response.data.byteLength !== 0) {

                        var blob = new Blob([response.data], {type: 'image/png'});

                        var reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = () => {
                            this.setState({...this.state, imagePreviewURL: reader.result, fetchedImage: true});
                        };
                    } else {
                        this.setState({...this.state, imagePreviewURL: null, fetchedImage: true})
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        }
    }

    showModal() {
        let modal = document.getElementById("modal" + this.state.version);
        modal.style.display = "block";
    }

    hideModal() {
        let modal = document.getElementById("modal" + this.state.version);
        modal.style.display = "none";
    }

    handleClick(e) {
        this.refs.fileUploader.click();
    }

    handleSubmit(file, imagePreviewUrl) {
        const url = "/api/campaigns/upload-company-image";

        if (this.state.linkedin_company_id) {

            let data = {
                campaign_id: this.state.campaign_id,
                linkedin_company_id: this.state.linkedin_company_id,
                image: file,
                ad_number: this.state.version === "A" ? 1 : 2
            };


            ApiService.post(url,data)
                .then(response => {
                    console.log(response.data);
                })
                .catch(error => {
                    console.log(error);
                });

            this.setState({...this.state, file: file, imagePreviewURL: imagePreviewUrl});

        }
        this.hideModal();
        this.forceUpdate();
    }

    handleImageChange(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({...this.state, file: file, imagePreviewURL: reader.result});
            this.props.onChangeValue(this.state.version, file);
        };

        reader.readAsDataURL(file);
    }

    render() {
        let imagePreviewUrl = this.state.imagePreviewURL;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img src={imagePreviewUrl} alt="Preview"
            className="img-thumbnail mt-2"
            height={200}
            width={200}
            />)
        } else {
            $imagePreview = (
                <div className="image-box">
                    <div className="previewText">Please select an Image for Preview</div>
                </div>
            );

        }

        return (
            <div className="previewComponent">
                <form>
                    <input className="fileInput"
                        type="file"
                        ref="fileUploader"
                        style={{display: "none"}}
                        onChange={(e)=>this.handleImageChange(e)} />
                </form>
                <Modal version={this.state.version}
                    imagePreviewURL={this.state.imagePreviewURL}
                    onClose={this.hideModal.bind(this)}
                    onChangeValue={this.handleSubmit.bind(this)}
                />


                <div className="image-box" onClick={this.showModal.bind(this)}>
                    {$imagePreview}
                </div>
            </div>
    )
}

}

export default UploadImage;